// src/infrastructure/payment/HttpPaymentBankReturnRepository.ts
import type { HttpClient } from '../http/HttpClient'
import type {
  BankReturnDraft,
  PaymentBankReturnRepository,
  RegisteredBankReturn,
} from '@/domain/payment/BankReturn'
import type { PaymentStatusKey } from '@/utils/paymentStatusLabel'

interface RawBankReturn {
  payment_id: number
  payment_status: PaymentStatusKey
  batch_id?: number | null
  returned_at?: string | null
  returned_by?: string | null
  bank_reference: string
  return_date: string
  return_amount: string
  return_reason?: string | null
}

export class HttpPaymentBankReturnRepository implements PaymentBankReturnRepository {
  constructor(private http: HttpClient) {}

  async registerBankReturn(paymentId: number, draft: BankReturnDraft): Promise<RegisteredBankReturn> {
    const raw = await this.http
      .url(`purchases/payments/${paymentId}/bank-return`)
      .body({
        bank_reference: draft.bankReference,
        return_date: draft.returnDate,
        amount: draft.amount,
        // The API takes it as optional; sending '' keeps the payload shape stable either way.
        reason: draft.reason,
      })
      .post<RawBankReturn>()

    return {
      paymentId: raw.payment_id,
      paymentStatus: raw.payment_status,
      batchId: raw.batch_id ?? null,
      returnedAt: raw.returned_at ?? null,
      returnedBy: raw.returned_by ?? null,
      bankReference: raw.bank_reference,
      returnDate: raw.return_date,
      amount: raw.return_amount,
      reason: raw.return_reason ?? '',
    }
  }
}
